import { useEffect } from 'react'
import { useReselector } from '../../utils/sharedHooks'
import { getIsRequiredStepsOnboarding } from '@/selectors/user.selectors'
import {
  OFFER_SOURCES,
  useBankingAnalytics,
} from '@/features/banking/analytics'
import { UnitBanking } from './UnitBanking'

export const Banking = () => {
  const isOnboarding = useReselector(getIsRequiredStepsOnboarding)
  const { trackOfferViewed } = useBankingAnalytics()

  // Fire Banking Offer Viewed when UnitBanking mounts. Differentiate the
  // Onboarding Dashboard banking tab from the regular Dashboard banking tab
  // via the active onboarding state. No click event — the CTA lives inside
  // Unit's iframe and is unreachable.
  const offerSource = isOnboarding
    ? OFFER_SOURCES.OnboardingDashboardBankingTab
    : OFFER_SOURCES.DashboardBankingTab
  useEffect(() => {
    trackOfferViewed(offerSource)
  }, [offerSource, trackOfferViewed])

  return <UnitBanking />
}
